import { MAIN } from "../../../routes/constants";
import ProductClass from "./ProductClass";
import ViewProductClass from "./ViewProductClass";

//Module Page Routes
export const PRODUCTCLASS = MAIN + "/ProductClass";
export const EDIT_PRODUCTCLASS = PRODUCTCLASS + "/edit";
export const NEW_PRODUCTCLASS = PRODUCTCLASS + "/new";

const ProductClassRoutes = [
    {
        label: "PRODUCT CLASS",
        path: PRODUCTCLASS,
        component: ProductClass,
        exact: true,
        mainscreen: true
    }, {
        label: "VIEW PRODUCT CLASS",
        path: EDIT_PRODUCTCLASS + "/:id?",
        component: ViewProductClass,
        exact: true
    }, {
        label: "NEW PRODUCT CLASS",
        path: NEW_PRODUCTCLASS + "/:id?",
        component: ViewProductClass,
        exact: true
    }
];

export default ProductClassRoutes;